module.exports = __webpack_public_path__ + "static/img/duraReader-custom-high-pressure-laminate-CHPL13.a86e78c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/durareaders/duraReader-custom-high-pressure-laminate-CHPL13.jpg
// module id = 762
// module chunks = 0